import Cookies from 'js-cookie';

/**
 * notification-ribbon.js.
 *
 */

const notificationRibbon = {
  initNotificationRibbon: () => {
    if (document.getElementById('id-notification-ribbon')) {
      //get our notification ribbon and the close buttons
      const modalNotificationRibbon = document.querySelector('.notification-ribbon');
      const modalCloseNotificationRibbon = document.querySelectorAll('.close-notification-ribbon');

      //define our close function
      const closeNotificationRibbon = () => modalNotificationRibbon.classList.remove('active');

      modalCloseNotificationRibbon.forEach((element) => {
        //close click listeners:
        element.addEventListener('click', (e) => {
          e.preventDefault();
          closeNotificationRibbon(); // call our close function
          setCookieNotificationRibbon(); //set the cookie
        });
        // close key listeners:
        element.addEventListener('keyup', (e) => {
          if (e.keyCode === 13 || event.keyCode === 32) {
            e.preventDefault();
            closeNotificationRibbon(); // call our close function
            setCookieNotificationRibbon(); //set the cookie
          }
        });
      });

      //get cookie value
      const notificationRibbonCookieValue = Cookies.get('notificationRibbonCookie');

      //get data attribute id
      const modalRibbonAttributeValue = document.getElementById('id-notification-ribbon');
      const notificationRibbonAttributeValue = modalRibbonAttributeValue.getAttribute('data-value');

      //Check if the attribute value equals our current cookie value
      const setCookieNotificationRibbon = () => {
        if (notificationRibbonCookieValue !== notificationRibbonAttributeValue) {
          //cookie set to new value
          Cookies.set('notificationRibbonCookie', notificationRibbonAttributeValue, { expires: 2 });
        }
      };

      if (notificationRibbonCookieValue !== notificationRibbonAttributeValue) {
        //set active
        modalNotificationRibbon.classList.add('active');
      }
    }
  },
};

export default notificationRibbon;
